import React, { useEffect, useState } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import FastImage from "react-native-fast-image";
import { ImageModal, Loading } from "../../components/common";
import EmptyPicture from "app/components/common/EmptyPicture";
import { useDispatch, useSelector } from "react-redux";
import { getFilesToUpload } from "@microdoing/shared/services/upload/selectors";
import {
  getUserId,
  getUserProfilePictureUrl,
} from "@microdoing/shared/services/user/selectors";
import { resetUpload } from "@microdoing/shared/services/upload/actions";
import { updateUserPicture } from "@microdoing/shared/services/profileSettings/actions";
import { getProfilSettingsLoading } from "@microdoing/shared/services/profileSettings/selectors";
import UploadProfilePicture from "./UploadProfilePicture";
import { getRoute } from "@microdoing/shared/services/nav/selectors";
import normalize from "app/utils/normalize";

export const PICTURE_SIZE = normalize(110);

const ENDPOINT = "https://s3.eu-west-3.amazonaws.com/liife-db";

const styles = StyleSheet.create({
  main: {
    overflow: "visible",
    marginTop: -(PICTURE_SIZE / 3),
  },
  picture: {
    marginTop: -(PICTURE_SIZE / 3),
    position: "relative",
    minHeight: PICTURE_SIZE,
    height: PICTURE_SIZE,
    width: PICTURE_SIZE,
    borderRadius: PICTURE_SIZE / 2 - 1,
    overflow: "hidden",
  },
  uploadZone: {
    marginTop: -(PICTURE_SIZE / 3),
    position: "absolute",
    top: 0,
    left: 0,
    height: PICTURE_SIZE,
    width: PICTURE_SIZE,
    borderRadius: PICTURE_SIZE / 2,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
});

const ProfilePicture = ({
  isUserProfile = true,
  picture,
  firstName = "Microdoing",
}) => {
  const [isModalPictureOpen, setIsModalPictureOpen] = useState(false);

  const files = useSelector(getFilesToUpload);
  const userId = useSelector(getUserId);
  const pictureUrl = useSelector(getUserProfilePictureUrl);
  const loading = useSelector(getProfilSettingsLoading);
  const route = useSelector(getRoute);
  const isFocused = route === "UserProfile";

  const dispatch = useDispatch();

  const pictureFile = files?.[0];

  const openImages = () => {
    setIsModalPictureOpen(true);
  };

  useEffect(() => {
    if (!!pictureFile && isFocused) {
      const date = new Date().getTime();
      const uri = pictureFile?.uri?.replace("file://", "");
      dispatch(
        updateUserPicture({
          name: `${userId}-${date}`,
          uri,
          userId,
          picture: `${ENDPOINT}/${userId}-${date}`,
        }),
      );
      dispatch(resetUpload());
    }
  }, [pictureFile, isFocused]);

  const pictureToDisplay = isUserProfile ? pictureUrl : picture;

  return (
    <TouchableOpacity
      style={styles.main}
      onPress={openImages}
      disabled={!isUserProfile}
    >
      <UploadProfilePicture
        isModalVisible={isModalPictureOpen}
        setIsModalVisible={setIsModalPictureOpen}
      />
      {pictureToDisplay ? (
        isUserProfile ? (
          <FastImage
            maxHeight={PICTURE_SIZE}
            source={{ uri: pictureToDisplay }}
            modalImageStyle={styles.picture}
            style={styles.picture}
            resizeMode="cover"
          />
        ) : (
          <ImageModal
            maxHeight={PICTURE_SIZE}
            source={{ uri: pictureToDisplay }}
            modalImageStyle={[styles.picture, { borderRadius: 0 }]}
            borderRadius={PICTURE_SIZE / 2}
            style={{ borderRadius: PICTURE_SIZE / 2 }}
            resizeMode="cover"
          />
        )
      ) : null}
      {!pictureToDisplay && (
        <View style={styles.picture}>
          <EmptyPicture firstName={firstName} size={120} />
        </View>
      )}
      {loading && (
        <View style={styles.uploadZone}>
          <Loading size={40} />
        </View>
      )}
    </TouchableOpacity>
  );
};

export default ProfilePicture;
